export function digitalFilter(data, options) {
    let { digitalFilterValue = 0 } = options;
    let re = new Float64Array(data.re);
    let im = new Float64Array(data.im);
    let pointsToShift = Math.floor(digitalFilterValue);
    const skip = 0;
    pointsToShift += 0;
    const newRe = new Float64Array(re.length);
    const newIm = new Float64Array(im.length);
    newRe.set(re.slice(pointsToShift));
    newRe.set(re.slice(skip, pointsToShift), re.length - pointsToShift);
    newIm.set(im.slice(pointsToShift));
    newIm.set(im.slice(skip, pointsToShift), im.length - pointsToShift);
    return { re: newRe, im: newIm };
}
//# sourceMappingURL=digitalFilter.js.map